import React from "react"
import { useStyle } from "react-native-style-utilities"

import { useIsDarkMode } from "./AppThemeContextProvider"
import { Box } from "./Box"
import { COLORS } from "./theme/colors"

import type { BoxProps } from "./Box"

/**
 * A component that displays a horizontal divider.
 */
export function Divider({
  style,
  thickness = 1,
  ...rest
}: BoxProps & { thickness?: number }) {
  const isDark = useIsDarkMode()

  return (
    <Box
      {...rest}
      style={useStyle(
        () => [
          {
            backgroundColor: isDark
              ? COLORS.$divider.dark
              : COLORS.$divider.light,
            height: thickness,
          },
          style,
        ],
        [isDark, style, thickness],
      )}
    />
  )
}
